export default "__VITE_ASSET__9461eefa__"